import { nl } from "../../i18n/nl";
import { SearchPanel } from "./SearchPanel";
import styles from "./search.module.css";

/** `/zoeken`: the mobile search screen (and a deep link on desktop). */
export function SearchPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{nl.screens.search}</h1>
      <SearchPanel autoFocusInput />
    </div>
  );
}
